import react, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useAxios from '../../Hooks/use-axios';
import { getConfig } from '../../utils/config';

const useData = ({ isPast, checkProtectedEvents }) => {
    const [events, setEvents] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [catalyst, setCatalyst] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [protectedEventsPresent, setProtectedEventsPresent] = useState(false);
    const config = getConfig();

    const loadMoreHandler = () => {
        setCurrentPage((prevState) => prevState + 1);
    };
    const authToken = useSelector((state) => state.auth.token);

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    // const headers2 = {
    //     'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    //     Authorization: `Bearer ${authToken}`
    // };
    // const dateCompare = (date) => {
    //     const date2 = new Date(date);
    //     const eventDate = date2.getTime();
    //     const currentDate = today.getTime();

    //     if (currentDate > eventDate) {
    //         // console.log(currentDate, 'greater', eventDate);
    //         return false;
    //     } else {
    //         // console.log(currentDate, 'lesser', eventDate);
    //         return true;
    //     }
    // };

    const onFilterClick = (tag) => {
        setEvents([]);
        if (selectedCategories.includes(tag)) {
            setSelectedCategories(selectedCategories.filter((t) => t !== tag));
        } else {
            setSelectedCategories(selectedCategories.concat(tag));
        }
        if (currentPage === 1) {
            setCatalyst((prevState) => prevState + 1);
        } else {
            setCurrentPage(1);
        }
    };
    const { isLoading, error, sendRequest: fetchEvents } = useAxios();
    const {
        isLoading: loadingProtectedEvents,
        error: protectedEventsError,
        sendRequest: fetchProtectedEvents
    } = useAxios();

    const getProtectedEvents = () => {
        // console.log('GET PROTECTED EVENTS');

        let url = `/cms_service/events/filter-v2?status=PUBLISHED&clientId=${
            config?.id
        }&isPast=false&isVisibleToAll=false&pageNumber=${
            currentPage - 1
        }&pageSize=20`;

        fetchProtectedEvents(
            {
                url,
                method: 'get',
                isFormData: true
            },
            (data) => {
                // console.log('EVENTS', data);
                setProtectedEventsPresent(data?.content.length > 0);
            }
        );
    };

    const getEvents = () => {
        // console.log('GET EVENTS', isPast);
        let url;
        if (isAuthenticated) {
            url = `/winnre/user/events/filter-v2?pageNumber=${
                currentPage - 1
            }&status=PUBLISHED&isPast=${isPast}&sortBy=startDate&isAscending=false&pageSize=4${
                selectedCategories.length > 0
                    ? `&tagList=${selectedCategories.join(',')}`
                    : ''
            }`;
        } else {
            url = `/cms_service/events/filter-v2?status=PUBLISHED&clientId=${
                config?.id
            }&isPast=${isPast}&isVisibleToAll=true&sortBy=startDate&pageNumber=${
                currentPage - 1
            }&pageSize=4${
                selectedCategories.length > 0
                    ? `&tagList=${selectedCategories.join(',')}`
                    : ''
            }`;
        }

        fetchEvents(
            {
                isEncryptedResponse: isAuthenticated ? true : false,
                url,
                method: 'get',
                isFormData: true
            },
            (data) => {
                console.log('Total EVENTS', data);
                if (isAuthenticated) {
                    if (data?.status === 'UNAUTHORIZED') {
                        setEvents([]);
                        setTotalPages(0);
                        return;
                    }
                    if (data?.status === 'FAILED') {
                        setEvents([]);
                        setTotalPages(0);
                        return;
                    }
                    if (data?.status === 'TOKEN_EXPIRED') {
                        setEvents([]);
                        setTotalPages(0);
                        return;
                    }
                    setTotalPages(data?.totalPages);
                    setEvents((prevState) => prevState.concat(data.content));
                } else {
                    setTotalPages(data.totalPages);
                    setEvents((prevState) => prevState.concat(data.content));
                }
            }
        );
    };

    useEffect(() => {
        setEvents([]);
        if (isAuthenticated) {
            setCurrentPage(1);
        }
    }, [isAuthenticated]);
    useEffect(() => {
        getEvents();
        if (checkProtectedEvents) {
            getProtectedEvents();
        }
    }, [currentPage, catalyst, selectedCategories, isAuthenticated]);

    return {
        events,
        isLoading,
        error,
        onFilterClick,
        selectedCategories,
        currentPage,
        setCurrentPage,
        loadMoreHandler,
        totalPages,
        setEvents,
        protectedEventsPresent
    };
};

export default useData;
